import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuthSession } from '@/entities/auth/api/hooks';
import { useAccessMatrix } from '@/entities/admin/api/hooks';
import { canAccessRoute } from '@/shared/lib/permissions';

export function RequireAccess() {
  const { data: session } = useAuthSession();
  const { data: matrix } = useAccessMatrix();
  const { pathname } = useLocation();

  if (!session?.user || !matrix) return <Outlet />;

  const routeKey = '/' + pathname.split('/')[1];
  const hasAccess = canAccessRoute(matrix, session.user.role, routeKey === '/' ? '/' : routeKey);

  if (!hasAccess) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
}
